var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 19.5,
    stroke: "#456B71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6665 12.667V15.167",
    stroke: "#52848B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3335 12.667V15.167",
    stroke: "#52848B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 13.917C27.1083 14.067 28.5 15.1253 28.5 19.042V24.192C28.5 27.6253 27.6667 29.342 23.5 29.342H18.5C14.3333 29.342 13.5 27.6253 13.5 24.192V19.042C13.5 15.1253 14.8917 14.0753 17.6667 13.917H24.3333Z",
    stroke: "#52848B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2918 25.667H13.7085",
    stroke: "#52848B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.875C19.975 17.875 19.1083 18.4333 19.1083 19.5167C19.1083 20.0333 19.35 20.425 19.7167 20.675C19.2083 20.975 18.9167 21.4583 18.9167 22.025C18.9167 23.0583 19.7083 23.7 21 23.7C22.2833 23.7 23.0833 23.0583 23.0833 22.025C23.0833 21.4583 22.7917 20.9667 22.275 20.675C22.65 20.4167 22.8833 20.0333 22.8833 19.5167C22.8833 18.4333 22.025 17.875 21 17.875ZM21 20.2417C20.5667 20.2417 20.25 19.9833 20.25 19.575C20.25 19.1583 20.5667 18.9167 21 18.9167C21.4333 18.9167 21.75 19.1583 21.75 19.575C21.75 19.9833 21.4333 20.2417 21 20.2417ZM21 22.6667C20.45 22.6667 20.05 22.3917 20.05 21.8917C20.05 21.3917 20.45 21.125 21 21.125C21.55 21.125 21.95 21.4 21.95 21.8917C21.95 22.3917 21.55 22.6667 21 22.6667Z",
    fill: "#52848B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e404c458f14fed09459957622fd0cd19.svg";
export { ForwardRef as ReactComponent };